import {
  Datagrid, List, TextField, BooleanField, DateField, EditButton,
  SelectInput, TextInput,
} from 'react-admin';

export const NEWS_CATEGORIES = [
  { id: 'notice', name: 'Notice' },
  { id: 'story', name: 'Story' },
  { id: 'event', name: 'Event' },
  { id: 'achievement', name: 'Achievement' },
  { id: 'in_memoriam', name: 'In memoriam' },
];

export const NEWS_STATUSES = [
  { id: 'draft', name: 'Draft' },
  { id: 'published', name: 'Published' },
];

const newsFilters = [
  <TextInput key="q" source="q" label="Search title/excerpt" alwaysOn />,
  <SelectInput key="category" source="category" choices={NEWS_CATEGORIES} alwaysOn />,
  <SelectInput key="status" source="status" choices={NEWS_STATUSES} alwaysOn />,
];

export const NewsList = () => (
  <List
    sort={{ field: 'publishedAt', order: 'DESC' }}
    filters={newsFilters}
    perPage={25}
  >
    <Datagrid rowClick="edit" bulkActionButtons={false}>
      <TextField source="title" />
      <TextField source="category" />
      <TextField source="status" />
      <BooleanField source="isFeatured" label="Featured" />
      <DateField source="publishedAt" label="Published" showTime />
      <EditButton />
    </Datagrid>
  </List>
);
